module.exports = __webpack_public_path__ + "static/AwareSuper-92328cbe29b528fcd3902a192140b86f.png";